module.exports = __webpack_public_path__ + "img/calera.22489edd.jpg";